import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface AddonRemoveConfirmationDialogData {
  addonTitle: string;
}

export interface AddonRemoveConfirmationDialogResult {
  confirmed: true;
  churnReason: string;
}

export const ADDON_REMOVE_CHURN_REASONS = [
  { value: 'got_value', labelKey: 'billing.addonChurnReasonGotValue' },
  { value: 'not_using', labelKey: 'billing.addonChurnReasonNotUsing' },
  { value: 'didnt_understand', labelKey: 'billing.addonChurnReasonDidntUnderstand' },
  { value: 'no_value', labelKey: 'billing.addonChurnReasonNoValue' },
] as const;

@Component({
  selector: 'app-addon-remove-confirmation-dialog',
  templateUrl: './addon-remove-confirmation-dialog.component.html',
  styleUrls: ['./addon-remove-confirmation-dialog.component.scss'],
})
export class AddonRemoveConfirmationDialogComponent {
  selectedChurnReason: string | null = null;

  readonly churnReasons = ADDON_REMOVE_CHURN_REASONS;

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: AddonRemoveConfirmationDialogData,
    private readonly dialogRef: MatDialogRef<
      AddonRemoveConfirmationDialogComponent,
      AddonRemoveConfirmationDialogResult | undefined
    >,
    private readonly translate: TranslateService,
  ) {}

  onKeep(): void {
    this.dialogRef.close(undefined);
  }

  onRemove(): void {
    if (!this.selectedChurnReason) {
      return;
    }
    const selected = this.churnReasons.find(r => r.value === this.selectedChurnReason);
    const churnReason = selected
      ? this.translate.instant(selected.labelKey)
      : this.selectedChurnReason;
    this.dialogRef.close({ confirmed: true, churnReason });
  }
}
